export interface ILicenseTypes {

  id?: number;
  uuid?: string;
  abbreviate: string;
  description: string;
  renewable: boolean;
  expire: boolean; 
  issue_organ?: [
    {
    id:number
    uuid:string
    name:string
    }
  ]; 
}


export const LicenseTypesInitValues: ILicenseTypes = {
 //id: 0,
 abbreviate: '',
 description: '',
 renewable: false,
 expire: false, 
}

